<div class="flex d-flex-justify-between pt-6 px-10">
  <h3 class="product-heading-bold">Application Settings</h3>
  <scope-ui-options-menu
    class="ml-4"
    buttonText="Add"
    [menuOptions]="menuOptions" />
</div>

<div
  *ngIf="!isLoading; else loader"
  class="application-settings pt-6 pb-10 px-10">
  <mat-expansion-panel
    *ngFor="let category of ApplicationSettingCategoryOrder"
    class="category"
    togglePosition="before"
    [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="category-title">
        {{ ApplicationSettingCategoryName[category] | langf }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div
      *ngFor="let setting of settings[category] | sortByOrder"
      class="category-settings"
      [isEllipsisActive]="setting.description">
      <scope-ui-toggle
        [title]="setting.name | langf"
        [description]="setting.description | langf"
        [isDisabled]="isSettingDisabled(setting)"
        [initialValue]="isSettingActive(setting)"
        (onToggleChange)="updateSetting(setting, $event)">
      </scope-ui-toggle>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="isTrafficable"
    class="category"
    togglePosition="before"
    [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="category-title">
        {{ ApplicationSettingCategoryName.CACHING }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="category-settings">
      <p>Traffic Import Cache</p>
      <button
        mat-button
        (click)="clearTrafficImportCache()">
        Clear
      </button>
    </div>
  </mat-expansion-panel>
</div>

<ng-template #loader>
  <div class="application-settings-loader">
    <img
      src="https://s3-eu-west-1.amazonaws.com/scopetrackermediastatic/main_load_spinner.gif"
      alt="" />
  </div>
</ng-template>
